var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProfileNotViewable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "168px",
    height: "137px",
    viewBox: "0 0 168 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icProfileNotViewable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-0.8%",
    width: "102.3%",
    height: "101.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skeliton-for-profile-not-found",
    transform: "translate(-367.000000, -237.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(262.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brooke-cagle-32432",
    transform: "translate(3.623256, 3.623256)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icProfileNotViewable",
    transform: "translate(105.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.586889,44.2040341 C132.887299,38.5750811 126.49833,33.8816064 119.615396,30.1718583 L145.532246,4.57620479 C146.593456,3.52814734 146.593456,1.83410053 145.532246,0.786043083 C144.471037,-0.262014361 142.755732,-0.262014361 141.694522,0.786043083 L114.496622,27.6441904 C103.830246,22.8193735 92.1515146,20.264901 80.0683837,20.264901 C57.9621166,20.264901 37.1803257,28.7646201 21.5498785,44.2040341 L0,65.4868374 L22.0872684,87.3003706 C27.5778735,92.7229287 33.7144321,97.2689784 40.309672,100.911715 L15.4893145,125.424465 C14.4281051,126.472523 14.4281051,128.16657 15.4893145,129.214627 C16.0185621,129.737316 16.7133693,130 17.4081764,130 C18.1029836,130 18.7977908,129.737316 19.3270384,129.214627 L45.3633085,103.501034 C56.2468114,108.564411 68.2159505,111.236823 80.6030595,111.236823 C102.709327,111.236823 123.491118,102.737104 139.121565,87.2976902 L160.674157,66.0122064 L138.586889,44.2040341 Z M44.296671,96.9768089 C37.6172943,93.4600535 31.4291679,88.9461693 25.9249924,83.5102089 L7.67544792,65.4868374 L25.3903166,47.9915153 C39.9948375,33.5679933 59.414155,25.6231282 80.0683837,25.6231282 C90.6614789,25.6231282 100.920741,27.724604 110.38206,31.7077584 L44.296671,96.9768089 Z M136.718431,83.5102089 C122.11391,97.9337309 102.694593,105.878596 82.0403643,105.878596 C71.143291,105.878596 60.5990494,103.645778 50.9151745,99.440146 L117.033133,34.1416104 C124.008346,37.7146554 130.470595,42.34916 136.183756,47.9941958 L154.4333,66.0175673 L136.718431,83.5102089 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1120662,32.1348315 C61.7120897,32.1348315 46.741573,47.5330771 46.741573,66.4587673 C46.741573,73.1730572 48.653959,79.4226538 51.9062986,84.7191011 L97.8651685,37.4471206 C92.7158448,34.101857 86.639848,32.1348315 80.1120662,32.1348315 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3483146,93.754467 C66.5488753,97.2656625 72.755996,99.3258427 79.4282696,99.3258427 C97.6480246,99.3258427 112.47191,84.0784176 112.47191,65.3380982 C112.47191,58.4751882 110.468957,52.0907211 107.055295,46.741573 L61.3483146,93.754467 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileNotViewable);
export default __webpack_public_path__ + "static/media/icProfileNotViewable.b29b805d0796be857dbc962fea4d2b34.svg";
export { ForwardRef as ReactComponent };